import React, { Component } from 'react';
import {withRouter} from 'react-router-dom'
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {firestoredb} from "../App";
import Crummy from "../Components/Crummy";

class Artist extends Component {

    constructor(props) {
        super(props);

      this.getArtist = this.getArtist.bind(this);
      this.breadcumb = this.breadcumb.bind(this);

        if (props.match) {
            // console.log("props.match.params.id: " + props.match.params.id);
            // console.log(props.match.params);
            // console.log(props);
        } else {
            // console.log(props);
        }

        this.state = {
            id: (props.match)?props.match.params.id:null,
            artist: null,
            loading: true,
            error: null
        };

        this.getArtist();

    }

    getArtist() {
        if (this.state.id === null) {
            this.setState({error:"Artist Not Found"});
            this.setState({loading:false});
            return;
        }


        var docRef = firestoredb.collection("users").doc(this.state.id);

        docRef.get().then((doc) => {
            if (doc.exists) {
               // console.log("Document data:", doc.data());
                 this.setState({artist:doc.data()});
            } else {
                this.setState({error:"Artist Not Found"});
              //  console.log("No such document!");
            }
            this.setState({loading:false});
        }).catch((error) => {
           // console.log("Error getting document:", error);
            this.setState({error:error});
            this.setState({loading:false});
        });
    }

  gotoArtists(event) {
    event.preventDefault();
    this.props.history.push('/artists');
  }


  breadcumb() {

      if (this.state.artist === null) {
        return (
          <Crummy
            paths={
              [
                {'name': 'Home', 'path': '/'},
                {'name' : 'Artists', 'path' : '/artists'},
              ]
            }/>
        );
      }

      return (
        <Crummy
          paths={
            [
              {'name': 'Home', 'path': '/'},
              {'name' : 'Artists', 'path' : '/artists'},
            ]
          } page={this.state.artist.email}/>
      );
    }

  render() {

    const breadcrumb = this.breadcumb();

        if (this.state.error) {
            return (
                <Grid>
                  {breadcrumb}
                    <Row>
                        <PageHeader>Artist</PageHeader>
                    </Row>
                    <Row>
                        {this.state.error}
                    </Row>
                </Grid>
            );
        }


        if (!this.state.id) {
            return (
                <Grid>
                  {breadcrumb}
                  <Row>
                        <PageHeader>Artist</PageHeader>
                    </Row>
                    <Row>
                        No artist passed in
                    </Row>
                </Grid>
            );
        }

        if (this.state.loading === true) {
            return (
            <Grid>
              {breadcrumb}
                <Row>
                    <PageHeader>Artist</PageHeader>
                </Row>
                <Row>
                    <div>
                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                    </div>
                </Row>
            </Grid>
            );
        }

        let artist = this.state.artist;

        if (!artist.isArtist) {
            return (
                <Grid>
                  {breadcrumb}
                  <Row>
                        <PageHeader>Artist</PageHeader>
                    </Row>
                    <Row>
                        This person is does not have an artist profile
                    </Row>
                </Grid>
            );
        }


        return (
      <Grid>
        {breadcrumb}
        <Row>
          <PageHeader>Artist</PageHeader>
        </Row>
          <Row>
              Artist: {this.state.id}
              <br/>
              displayName: {artist.displayName}
              <br/>
              email: {artist.email}
              <br/>
              isArtist: { (artist.isArtist) ? "true" : "false" }

          </Row>
      </Grid>
    );
  }
}
export default withRouter(Artist);



// WEBPACK FOOTER //
// ./src/pages/Artist.jsx